var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-edit-content" }, [
    _c(
      "table",
      { staticClass: "matrix-table", class: { isShow: !_vm.value.ext.edit } },
      [
        _vm.value.ext.edit
          ? _c("tr", [
              _c("td", { staticStyle: { width: "30px", height: "28px" } }),
              _vm._v(" "),
              _c("td"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _vm.value.ext.edit
            ? _c("td", { staticStyle: { height: "35px" } })
            : _vm._e(),
          _vm._v(" "),
          _c("td"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.value.detail.row, function (item, index) {
          return _c("tr", { key: index }, [
            _vm.value.ext.edit
              ? _c("td", [
                  _c(
                    "span",
                    {
                      staticClass: "remove",
                      on: {
                        click: function ($event) {
                          return _vm.delRowItem(index)
                        },
                      },
                    },
                    [_vm._v("删")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "td",
              [
                _vm.value.ext.edit
                  ? _c("com-input", {
                      class: { error: item.error },
                      attrs: { "max-length": 5 },
                      on: {
                        focus: function ($event) {
                          return _vm.itemFocus(item)
                        },
                      },
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.value.ext.edit
                  ? _c("span", {
                      domProps: { textContent: _vm._s(item.value) },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { ref: "tb", staticClass: "main-table" }, [
      _c(
        "table",
        {
          staticClass: "matrix-table",
          class: { isShow: !_vm.value.ext.edit },
          style: { left: _vm.left + "px" },
        },
        [
          _vm.value.ext.edit
            ? _c(
                "tr",
                _vm._l(_vm.value.detail.column, function (item, index) {
                  return _c("td", { key: index }, [
                    _c(
                      "span",
                      {
                        staticClass: "remove",
                        on: {
                          click: function ($event) {
                            return _vm.delColumnItem(index)
                          },
                        },
                      },
                      [_vm._v("删")]
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "tr",
            _vm._l(_vm.value.detail.column, function (item, index) {
              return _c(
                "td",
                { key: index },
                [
                  _vm.value.ext.edit
                    ? _c("com-input", {
                        class: { error: item.error },
                        attrs: { "max-length": 5 },
                        on: {
                          focus: function ($event) {
                            return _vm.itemFocus(item)
                          },
                        },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.value.ext.edit
                    ? _c("span", {
                        domProps: { textContent: _vm._s(item.value) },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm._l(_vm.value.detail.row, function (itemRow, indexRow) {
            return _c(
              "tr",
              { key: indexRow },
              _vm._l(_vm.value.detail.column, function (itemCol, indexCol) {
                return _c(
                  "td",
                  { key: indexCol },
                  [
                    _vm.value.detail.format === "radio"
                      ? _c("vh-radio", {
                          attrs: { label: indexRow + 1 + "-" + (indexCol + 1) },
                          model: {
                            value: itemRow.selected,
                            callback: function ($$v) {
                              _vm.$set(itemRow, "selected", $$v)
                            },
                            expression: "itemRow.selected",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.value.detail.format === "checkbox"
                      ? _c("vh-checkbox", {
                          attrs: { label: indexRow + 1 + "-" + (indexCol + 1) },
                          model: {
                            value: itemRow.selected,
                            callback: function ($$v) {
                              _vm.$set(itemRow, "selected", $$v)
                            },
                            expression: "itemRow.selected",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    !_vm.value.ext.edit && _vm.errorTip
      ? _c("div", { staticClass: "error-msg" }, [
          _vm._v(_vm._s(_vm.errorTip) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }